/** 车辆档案详情组件 
 *  创建时间：2017-03-30 
 * 创建人：Shujuan Sun 
 */
<template>                                                                      
	<div id="PageRescureImportEdit" class="wrapper-content fadeInRight animated tabBox">
		<div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
      <div class="form-horizontal" style="padding:30px 20px">
        <div class="form-group">
          <label for="" class="col-sm-1 control-label red">*保单号:</label>
          <div class="col-sm-3" :class="{'form-group--error': $v.dataInfo.policyNo.$error }">
              <input type="text" class="form-control"
              @input="$v.dataInfo.policyNo.$touch()" v-model="dataInfo.policyNo" maxLength="23"  :disabled="mode=='view'">
              <span class="cus_message form-group__message"  v-if="!$v.dataInfo.policyNo.required && $v.dataInfo.policyNo.$error">保单号为必填项</span>
          </div>
          <label class="col-sm-1 control-label red">*车牌号</label>
          <div class="col-sm-3"  v-bind:class="{'form-group--error': $v.dataInfo.rescuedPlateNumber.$error }">
            <input type="text" class="form-control" v-model.trim="dataInfo.rescuedPlateNumber"  @keyup="setUpperCase"  @blur="isPlateNumberOk"   @input="$v.dataInfo.rescuedPlateNumber.$touch()" maxLength="20" :disabled="mode=='view'">
            <span class="cus_message form-group__message" v-if="!$v.dataInfo.rescuedPlateNumber.required && $v.dataInfo.rescuedPlateNumber.$error">该车牌号为必填项</span>
          </div>
          <label class="col-sm-1 control-label">车主姓名</label>
          <div class="col-sm-3">
            <input type="text" class="form-control" v-model="dataInfo.rescuedName" maxlength="20" :disabled="mode=='view'">
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-1 control-label red">*手机号</label>
          <div class="col-sm-3"  v-bind:class="{'form-group--error': $v.dataInfo.rescuedPhone.$error }">
            <input type="text" class="form-control" v-model.trim="dataInfo.rescuedPhone"  @input="$v.dataInfo.rescuedPhone.$touch()" maxlength="11" :disabled="mode=='view'">
            <span class="cus_message form-group__message" v-if="!$v.dataInfo.rescuedPhone.required && $v.dataInfo.rescuedPhone.$error">手机号为必填项</span>
            <span class="cus_message form-group__message" v-if="!phoneSet">请输入有效手机号</span>
          </div>
          <label class="col-sm-1 control-label red">*救援类型</label>
          <!--待救援以外都不可编辑-->
          <div class="col-sm-3" v-bind:class="{'form-group--error': $v.dataInfo.rescueType.$error }">
            <div class="col-sm-3 control-label t_left" v-for="(type,index) in rescueTypeList" :key="index" >
              <input type="radio" :value="type.udccode" v-model="dataInfo.rescueType"  :disabled="mode=='view'"/>
              <span>{{type.udcname}}</span>
            </div>
            <span class="cus_message form-group__message" v-if="!$v.dataInfo.rescueType.required && $v.dataInfo.rescueType.$error">救援类型为必填项</span>
          </div>
          <label class="col-sm-1 control-label red">*请求时间</label>
          <div class="col-sm-3" v-bind:class="{'form-group--error': $v.dataInfo.requestTime.$error }">
             <datepicker v-model.trim="dataInfo.requestTime" :time_24hr="true" v-if="mode =='add'"   :enableTime="true" :enableSeconds="true" ref="requestDate" @change="$v.dataInfo.requestTime.$touch()" class="form-control"></datepicker>
            <span class="cus_message form-group__message" v-if="!$v.dataInfo.requestTime.required && $v.dataInfo.requestTime.$error">请求时间为必填项</span>
            <input type="text" class="form-control" v-model.trim="dataInfo.requestTime" v-if="mode =='view'"  maxlength="11" disabled>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-1 control-label red">*救援地址</label>
          <div class="col-sm-3">
            <input type="text" class="form-control" v-model="dataInfo.rescuedAddress" maxlength="200" @input="$v.dataInfo.rescuedAddress.$touch()"  :disabled="mode=='view'">
             <span class="cus_message form-group__message" v-if="!$v.dataInfo.rescuedAddress.required && $v.dataInfo.rescuedAddress.$error">救援地址为必填项</span>
          </div>          
        </div> 
        <div class="form-group" style="margin-top:300px">
          <div class="col-sm-12 text-center">
                  <button  class="btn btn-primary white" @click="handleSave" :disabled="!clickable" v-if="mode=='add'">保存</button>
          </div>
        </div>      
      </div>
      <tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
          {{messageStr}}
          <div slot="footer">
                <button @click="closeModalMsg" class="btn btn-primary">确定</button>
            </div>
        </tab-modal>
        <tab-modal ref="successModal" size="small" :scroll='scrollTop' title="提示" v-on:cancel="saveSuccess">
          保存成功！
          <div slot="footer">
                <button @click="saveSuccess" class="btn btn-primary">确定</button>
            </div>
        </tab-modal> 
		</div>
	</div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { OPERATE_EXCEPTION } from 'static/message'
import classlist from 'util/classlist'
import Datepicker from 'components/common/datepicker/Datepicker'
import TabModal from 'components/common/TabModal'
export default {
  name: '',
  components: {
    Datepicker, TabModal
  },
  beforeMount () {
    let route = this.$route
    this.rescueTypeList = route.query.rescureList
    this.mode = route.query.mode
    if (this.mode == 'view') {
      this.dataInfo.id = route.query.id
      this.getDetail()
    }
  },
  data () {
    return {
      scrollTop: '',
      mode: '',
      messageStr: '',
      loadingstatus: false,
      dataInfo: {
        policyNo: '',
        rescuedPlateNumber: '',
        rescuedPhone: '',
        rescuedName: '',
        rescueType: 1,
        requestTime: '',
        rescuedAddress: '',
        id: ''
      }
    }
  },
  computed: {
    clickable () {
      return this.$v.dataInfo.policyNo.required && this.$v.dataInfo.rescuedPlateNumber.required && this.$v.dataInfo.rescuedPhone.required &&
      this.$v.dataInfo.requestTime.required && this.phoneSet && this.$v.dataInfo.rescuedAddress.required
    }
  },
  validations: {
    dataInfo: {
      policyNo: {
        required
      },
      rescuedPlateNumber: {
        required
      },
      rescuedPhone: {
        required
      },
      rescueType: {
        required
      },
      requestTime: {
        required
      },
      rescuedAddress: {
        required
      }
    }
  },
  methods: {
    getDetail () {
      this.loadingstatus = true
      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/entryOrders/' + this.dataInfo.id).then(res => {
        const resInfo = res.body.data
        this.dataInfo = resInfo
        this.loadingstatus = false
      }, res => {
        this.loadingstatus = false
        this.openModalMsg(res.body.message)
        if (res.body.message == '') {
          this.openModalMsg('请求出问题啦，请稍后重试')
        }
      })
    },
    handleSave () {
      if (!this.phoneSet()) {
        this.openModalMsg('手机号输入有误！')
        return
      }
      this.loadingstatus = true
      this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/saveEntryOrder', this.dataInfo, {emulateJSON: true}).then(res => {
        if (res.data.success) {
          this.loadingstatus = false
          this.$store.dispatch('refreshStatus')
          this.openSuccessModal()
        } else {
          this.loadingstatus = false
          this.openModalMsg(res.data.message)
        }
      }, res => {
        this.loadingstatus = false
        this.openModalMsg(res.data.message)
        if (res.body.message == '') {
          this.openModalMsg('请求出问题啦，请稍后重试')
        }
      }).catch(res => {
        this.loadingstatus = false
        this.openModalMsg(OPERATE_EXCEPTION)
      })
    },
    setUpperCase () {
      this.dataInfo.rescuedPlateNumber = this.dataInfo.rescuedPlateNumber.toUpperCase()
    },
    phoneSet () {
      if (!this.dataInfo.rescuedPhone) {
        return true
      } else {
        return /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/.test(this.dataInfo.rescuedPhone)
      }
    },
    isPlateNumberOk () { // 判断有无重复的车牌号或该车牌号存在在黑名单中
      if (!this.dataInfo.rescuedPlateNumber) {
        return
      }
      const param = {
        rescuedPlateNumber: this.dataInfo.rescuedPlateNumber,
        rescueId: this.dataInfo.id
      }
      this.loadingstatus = true
      this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/check/duplicate/plateNumber', {params: param}).then(res => {
        const noRepeat = res.body.data.status// true: 无重复  false:重复
        this.loadingstatus = false
        if (!noRepeat) {
          this.openModalMsg(res.body.data.describe)
        }
      }, res => {
        this.loadingstatus = false
        this.openModalMsg(res.body.message)
      })
    },
    closeModalMsg () {
      this.closeModal('modalMsg')
    },
    saveSuccess () {
      this.closeModal('successModal')
      $('.J_menuTab.active', window.top.document).find('.fa.fa-times-circle').click()
    },
    openSuccessModal (message) {
      this.openModal('successModal')
    },
    openModalMsg (message) {
      this.messageStr = message
      this.openModal('modalMsg')
    },
    openModal (ref) {
      this.$refs[ref].open()
      classlist.toggleScroll('close', '#PageRescureImportEdit', this)
    },
    closeModal (ref) {
      this.$refs[ref].close()
      classlist.toggleScroll('open', '#PageRescureImportEdit', this)
    }
  }

}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// PageRescureImportEdit.vue?4c584301